import { render, staticRenderFns } from "./create-staff-duty-leave-task.vue?vue&type=template&id=5969d448&scoped=true&"
import script from "./create-staff-duty-leave-task.vue?vue&type=script&lang=ts&"
export * from "./create-staff-duty-leave-task.vue?vue&type=script&lang=ts&"
import style0 from "./create-staff-duty-leave-task.vue?vue&type=style&index=0&id=5969d448&prod&lang=scss&scoped=true&"
import style1 from "./create-staff-duty-leave-task.vue?vue&type=style&index=1&id=5969d448&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969d448",
  null
  
)

export default component.exports